import React from 'react';
import { Modal, SparkModalPortal } from '@spark';

/**
 * Warning modal shown when a training-start validation fails ("Let's Train"
 * or scheduling auto-train). Replaces the old inline red message next to the
 * button, which was easy to miss inside the Retrain modal. Single "Got it"
 * button, no cancel.
 *
 * ``message`` is a string or ReactNode (the blocked messages embed
 * TrainBlockedLink spans that navigate to Settings / Model Configuration;
 * those handlers close this modal before navigating).
 */
const TrainBlockedModal = ({ message, onClose }) => {
    if (!message) return null;

    return (
        <SparkModalPortal open onClose={onClose} size="text">
            <Modal
                title="Can't start training"
                showSubtitle={false}
                feedbackType="warning"
                fixedHeight={false}
                showOverlay={false}
                showClose
                onCloseClick={onClose}
                showFooter
                showTertiaryButton={false}
                primaryLabel="Got it"
                onPrimaryClick={onClose}
                bodyVariant="text"
            >
                <div className="train-blocked-modal__message fs-unmask">{message}</div>
            </Modal>
        </SparkModalPortal>
    );
};

export default TrainBlockedModal;
